import styled from 'styled-components';
import { media } from '../../../style/media';
import { contiOrange } from '../../../style/colors';

export const TyreTable = styled.div`
  overflow-x: auto;
  flex: 1;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background: #f9fafb;
  position: sticky;
  top: 0;
`;

export const Th = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;

  ${media.s`
    padding: 8px 12px;
    font-size: 11px;
  `}
`;

export const Tbody = styled.tbody`
  tr:hover {
    background: #f9fafb;
  }
`;

export const Td = styled.td`
  padding: 12px 16px;
  font-size: 14px;
  color: #111827;
  border-bottom: 1px solid #f3f4f6;
  cursor: default;

  ${media.s`
    padding: 8px 12px;
    font-size: 13px;
  `}
`;

export const EditableCell = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: ${(props) => (props.$editing ? 'default' : 'pointer')};
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: ${(props) => (props.$editing ? '#fff7ed' : '#f3f4f6')};
  }

  ${(props) =>
    props.$editing &&
    `
    background: #fff7ed;
    border: 1px solid ${contiOrange};
  `}
  
  * {
    cursor: inherit;
  }
`;

export const PriceInput = styled.input`
  width: 80px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  color: #111827;
  cursor: text;

  &:focus {
    outline: none;
    border-color: ${contiOrange};
  }

  ${media.s`
    width: 70px;
    font-size: 13px;
  `}
`;

